import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'company-events-outlook',
    templateUrl: './company-events-outlook.component.html',
    styleUrls: ['./company-events-outlook.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsOutlookComponent {
  @Input() outlookAttendees:any[]

}
